import React from 'react'

import AnalyticsSectionContent, { IAnalyticsSectionContentProps } from './AnalyticsSectionContent'

const TopQueriesNoResults: React.SFC<IAnalyticsSectionContentProps> = (props) => (
  <AnalyticsSectionContent title="Top Queries with No Results" {...props} />
)

export default TopQueriesNoResults
